
export { default } from './draggable-dimension-publisher';


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/draggable-dimension-publisher/index.js
// module id = 1894
// module chunks = 1